import getServerErrorMessage from 'app/utilities/getServerErrorMessage';
import { SagaIterator } from 'redux-saga';
import {
  all,
  call,
  cancel,
  cancelled,
  fork,
  put,
  take,
} from 'redux-saga/effects';

import { validateResetTokenAPIRequest } from '../api';
import { TValidateResetPasswordServerResponse } from '../types';
import {
  cancelAuthTask,
  clearError,
  endAuthTask,
  onError,
  onResetTokenEmail,
  startAuthTask,
  validateTokenRequest,
} from './auth-slice';

export function* validateToken(payload: string): SagaIterator {
  try {
    yield put(startAuthTask());
    const {
      data: { email },
    }: TValidateResetPasswordServerResponse = yield call(
      validateResetTokenAPIRequest,
      payload
    );
    yield all([put(onResetTokenEmail(email)), put(clearError())]);
  } catch (error) {
    const errorMsg = getServerErrorMessage(error);
    yield put(onError(errorMsg));
  } finally {
    if (yield cancelled()) {
      yield put(clearError());
    }

    yield put(endAuthTask());
  }
}

export function* validateResetTokenFlow(): SagaIterator {
  while (true) {
    const { payload } = yield take(validateTokenRequest);
    const validateTokenTask = yield fork(validateToken, payload);
    const nextAction = yield take([cancelAuthTask, endAuthTask]);
    if (nextAction.type === cancelAuthTask.type) {
      yield cancel(validateTokenTask);
    }
  }
}
